const API_URLS = {
  baseUrl: '',
  customerAccount: 'https://api-mobile-ci-vfal.vodafone.com/enterprise-resources/public/customer/customer-accounts/',
  getProducts: 'https://api-mobile-ci-vfal.vodafone.com/auth/productOfferingAPI/v2/productOffering',
  gigaBonus: 'https://api-mobile-ci-vfal.vodafone.com/local/tmf-api/productOrderingManagement/v4/productOrder',
}

const COMMON_HEADERS = {
  'Content-Type': 'application/json',
}

export { API_URLS, COMMON_HEADERS }
